import Layout from "@/components/Layout";
import { PermisosContent } from "@/components/configuracion/PermisosContent";

export default function Permisos() {
  return (
    <Layout>
      <PermisosContent />
    </Layout>
  );
}
